// extracted by mini-css-extract-plugin
export default {"root":"styles_root__pMls9","content":"styles_content__sPDHC","table":"styles_table__U1Sz7","fixedCell":"styles_fixedCell__PpAK9","cell":"styles_cell__Ttiej"};